import Choices from 'choices.js'

export function decorateChoices() {
    new Choices('.js-choice');
}

export function decorateFormChoices() {
    const choices = document.querySelectorAll('.form-choices select')

    choices.forEach(el => {
        new Choices(el);
    })

}
